import type { GridCsvExportOptions, GridRowId } from '@mui/x-data-grid-pro';
import { csvOptionsValues } from './csvExportOptions';

export interface ApiDoGridParaExportacao {
  setRows: (linhas: Array<any>) => void;
  exportDataAsCsv: (opcoes: GridCsvExportOptions) => void;
  getAllRowIds: () => Array<GridRowId>;
}

export interface ExportarMovimentacoesParams {
  apiDoGrid: ApiDoGridParaExportacao;
  carregarTodasAsMovimentacoes: () => Promise<Array<any>>;
  movimentacoesDaPaginaAtual: Array<any>;
  nomeArquivo: string;
  agruparAtualizacoes: (acao: () => void) => void;
}

export const exportarMovimentacoes = async ({
  apiDoGrid,
  carregarTodasAsMovimentacoes,
  movimentacoesDaPaginaAtual,
  nomeArquivo,
  agruparAtualizacoes,
}: ExportarMovimentacoesParams): Promise<void> => {
  const todasAsMovimentacoes = await carregarTodasAsMovimentacoes();

  agruparAtualizacoes(() => {
    try {
      apiDoGrid.setRows(todasAsMovimentacoes);
      apiDoGrid.exportDataAsCsv({
        ...csvOptionsValues,
        fileName: nomeArquivo,
        getRowsToExport: ({ apiRef }) => apiRef.current.getAllRowIds(),
      });
    } finally {
      apiDoGrid.setRows(movimentacoesDaPaginaAtual);
    }
  });
};
